import { render, staticRenderFns } from "./BS_modal.vue?vue&type=template&id=34e0fdf8&scoped=true"
import script from "./BS_modal.vue?vue&type=script&lang=js"
export * from "./BS_modal.vue?vue&type=script&lang=js"
import style0 from "./BS_modal.vue?vue&type=style&index=0&id=34e0fdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e0fdf8",
  null
  
)

export default component.exports